import { compose } from 'redux';
import { connect } from 'react-redux';
import MicReadingCheckCard from './MicReadingCheckCard';
import { getTrcInstruction, getTrcCaption } from '../../troConstants';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { unmountScreen } from '../../../common/screen/screenActions';
import { narrateScreen, getReadingCheckResult } from '../../trcActions';
import { trackFailedMicReadingCheck, trackPassedReadingCheck } from '../../trcReporting';
import selectors from '../../../rootSelectors';
import {
    clearMicTestAttemptCount,
    clearRecordedResult,
    setRecordedResult,
} from '../../../common/recording/recordingActions';
import { setVerificationResult, setVerificationStatus } from '../../../common/api/trcoActions';
import { VERIFICATION_STATUS } from '../instructions/TROInstructionsConstants';
import { setShouldPreventAlexAnimation } from '../../../common/alex/AlexActions';

const instructionsKey = 'troMicReadingCheck';

const mapStateToProps = state => ({
    recordingStream: selectors.getRecordingStream(state),
    isRecordingInProgress: selectors.getIsRecordingInProgress(state),
    verificationStatus: selectors.selectVerificationStatus(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isSpinnerVisible: selectors.getIsSpinnerVisible(state),
    passedReadingCheck: selectors.getPassedReadingCheck(state),
    didAttemptMicReadingCheck: selectors.getDidAttemptMicReadingCheck(state),
    passedMicReadingCheck: selectors.getPassedMicReadingCheck(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    arLanguage: selectors.getArLanguage(state),
});

const mapDispatchToProps = dispatch => ({
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const instruction = getTrcInstruction(isExternalURLSourcePresent, instructionsKey, arLanguage);
        const caption = getTrcCaption(isExternalURLSourcePresent, instructionsKey, arLanguage);
        return dispatch(narrateScreen(instruction, caption));
    },
    cleanup: () => {
        dispatch(clearRecordedResult());
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
        dispatch(setVerificationResult({ reset_verification: true }));
        dispatch(setVerificationStatus(VERIFICATION_STATUS.IDLE));
        dispatch(clearMicTestAttemptCount());
    },
    updateVerificationProgress: isExternalURLSourcePresent => {
        if (isExternalURLSourcePresent) {
            dispatch(setShouldPreventAlexAnimation(isExternalURLSourcePresent));
        }
        dispatch(clearRecordedResult());
        dispatch(setVerificationResult({ reset_verification: true }));
        dispatch(setVerificationStatus(VERIFICATION_STATUS.IDLE));
    },
    onStopRecording: isExternalURLSourcePresent => {
        if (isExternalURLSourcePresent) {
            dispatch(setShouldPreventAlexAnimation(!isExternalURLSourcePresent));
        }
    },
    saveRecordedResult: async recordedResult => {
        await dispatch(setRecordedResult(recordedResult));
        dispatch(getReadingCheckResult());
    },
    trackFailedMicReadingCheck: () => dispatch(trackFailedMicReadingCheck()),
    trackPassedReadingCheck: () => dispatch(trackPassedReadingCheck()),
});

const avatarMapStateToProps = state => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: getTrcInstruction(selectors.getExternalURLSourceStatus(state), instructionsKey, selectors.getArLanguage(state)),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MicReadingCheckCard);
